const ws =
  process.env.NODE_ENV !== "production"
    ? new WebSocket("ws://localhost:8000/")
    : null;

const T = Object.freeze({
  OBJ: "object",
  DB: "database",
  LIST: "list",
  VAL: "val",
  PT: "pointer",
});

// const DataSource = null;
const DataSource = "/data/data_housecleaning.json";
const INTATTR = ["__id", "__parent", "__children"];

export { ws, T, DataSource, INTATTR };
